module.exports = __webpack_public_path__ + "static/media/AppGallery_Badge_en.a0d13e44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AppGallery_Badge_en.svg
// module id = 670
// module chunks = 21